import { FC } from "react";

import { Users } from "@/modules";

const AdminPage: FC = () => {
  return (
    <div data-testid="admin-page">
      <Users />
    </div>
  );
};

export default AdminPage;
